import { React, useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const France = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Country"    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Country"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const countries = [
        {
            img: "images/free-building-icon.png", universityname: "University of Aix-Marseille", location: "France", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$5952", para2: "NA", para3: "NA"
        },
        {
            img: "images/free-building-icon.png", universityname: "Universite de Lyon (ComUE)", location: "France", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$13890", para2: "NA", para3: "NA"
        },
        {
            img: "images/free-building-icon.png", universityname: "Communaute Universite Grenoble Alpes", location: "France", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$5566", para2: "NA", para3: "NA"
        },
        {
            img: "images/free-building-icon.png", universityname: "PSL Research University Paris (ComUE)", location: "France", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$4333", para2: "NA", para3: "NA"
        },
        {
            img: "images/free-building-icon.png", universityname: "Universite Sorbonne Paris Cite-USPC (ComUE)", location: "France", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$7563", para2: "NA", para3: "NA"
        },
        {
            img: "images/free-building-icon.png", universityname: "Universite Paris Saclay (ComUE)", location: "France", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$7031", para2: "NA", para3: "NA"
        }
    ]
    return (
        <>
            <BannerBreadcrumb head={"Universities in France for International Students"} pagename={"France"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">Discover France's Best Universities for Foreign Students</h5>
                            <p className="loan-elegibility-des">With plenty of international students attending its esteemed colleges, France provides an outstanding educational experience. France is an amazing place for learners who want to accomplish academic success because of its top-notch arts, science, and engineering programs given by institutions like École Normale Supérieure and Sorbonne University. France provides a distinctive educational setting that blends innovation and tradition. It is famous for its rich cultural past, active student body, and contemporary research facilities.</p>
                            <h5 className="about-head">Leveraging Credere to Gain Financial Support</h5>
                            <p className="loan-elegibility-des">Significant financial obstacles may arise when studying overseas, but Credere is here to make the process smoother. Our platform is intended to help students find and evaluate student loans from a variety of reliable lenders. We simplify and streamline the loan application procedure, whether you require financing for living expenses, college, or travel.</p>
                            <h5 className="about-head">Customized Loan Alternatives for Your Academic Goals</h5>
                            <p className="loan-elegibility-des">Students can investigate a variety of loan choices with Credere that are customized to meet their particular financial requirements. We deliver insightful information that makes comparing and assessing multiple financing solutions from leading financial organizations easy. You may focus on your studies and future profession without worrying about money thanks to our user-friendly platform, which makes sure you find the loan that matches your budget.</p>
                            <h5 className="about-head mb-4">Explore Our List of France Universities</h5>
                            <div className="row">
                                {countries.map((item, index) => (
                                    <div className="col-md-6">
                                        <div className="scholar-card">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <img src={item.img} alt="University Images" className="img-fluid countryimg" />
                                                </div>
                                                <div className="col-md-9 d-block my-auto">
                                                    <h5 className="scholar-head">{item.universityname}</h5>

                                                </div>
                                                <p className="scholar-des mb-0 mt-4" style={{ marginLeft: "-6px", fontSize: "16px" }}><LocationPinIcon /> {item.location}</p>
                                                <div className="col-md-12 mt-3">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head1}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades">{item.para1}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head2}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades">{item.para2}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head3}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades mb-0">{item.para3}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default France;